import { render, staticRenderFns } from "./ApprovalTes.vue?vue&type=template&id=7c40dd26&scoped=true"
import script from "./ApprovalTes.vue?vue&type=script&lang=js"
export * from "./ApprovalTes.vue?vue&type=script&lang=js"
import style0 from "./ApprovalTes.vue?vue&type=style&index=0&id=7c40dd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c40dd26",
  null
  
)

export default component.exports